import IB_Preset, { Custom_Preset } from '@bo-ibSheet/common';

const openApiCertificationOptions = {
  Cfg: {
    UseButton: 1,
  },
  LeftCols: [Custom_Preset.SEQ],
  Def: {
    Row: {
      Height: 44,
      CanFormula: true,
      CalcOrder: 'TextColor,invalidateCertificationKey',
      TextColorFormula: ({ Row }) => (Row['useYn'] === 'Y' ? '#333333' : '#BBBBBB'),
    },
  },
  Cols: [
    {
      Header: 'API인증KEY',
      Type: 'Text',
      Name: 'openApiCertificationKey',
      Key: 'OPEN_API_APPR_KEY',
      MinWidth: 120,
      Width: 1000,
      Align: 'Left',
      CanEdit: 0,
      RelWidth: 1,
      Size: 27,
    },
    {
      Header: '생성일시',
      Type: 'Date',
      Name: 'applyStartDateTime',
      Key: 'APPLY_START_DTIME',
      MinWidth: 120,
      Width: 150,
      Align: 'Center',
      CanEdit: 0,
      Size: 27,
      ...IB_Preset.YMD12HMS,
    },
    {
      Header: '만료일시',
      Type: 'Date',
      Name: 'applyEndDateTime',
      Key: 'APPLY_END_DTIME',
      MinWidth: 120,
      Width: 150,
      Align: 'Center',
      CanEdit: 0,
      Size: 27,
      ...IB_Preset.YMD12HMS,
    },
    {
      Header: '상태',
      Type: 'Text',
      Name: 'useYn',
      Key: 'USE_YN',
      MinWidth: 120,
      Width: 120,
      Align: 'Center',
      CanEdit: 0,
      Size: 27,
      Format: {
        Y: '사용가능',
        N: '사용불가',
      },
    },
  ],
};

export default {
  openApiCertificationOptions,
};
